<div class="flex items-stretch space-x-3">
	<div class="flex-1 truncate">
		<label [title]="controller.baseI18n + '.name.label' | translate">
			{{ controller.baseI18n + '.name.label' | translate }}
		</label>
	</div>
	<div class="flex-1 truncate">
		<label [title]="controller.baseI18n + '.institution.label' | translate">
			{{ controller.baseI18n + '.institution.label' | translate }}
		</label>
	</div>
	<div
		*ngIf="controller.calendarLocale$ | async; let calendarLocale"
		class="flex-1 truncate"
	>
		<label [title]="controller.baseI18n + '.dates.label' | translate">
			{{ controller.baseI18n + '.dates.label' | translate }}
		</label>
	</div>
	<div class="md:flex-none md:w-16 w-8">
		<ng-content></ng-content>
	</div>
</div>
